import ScrollMagic from 'scrollmagic'
import 'animation.gsap'
import 'debug.addIndicators'

var controller = new ScrollMagic.Controller();

Vue.directive('scroll-reveal', {
  inserted: (el, binding) => {

    let className = "";
    const characters = "abcdefghijklmnopqrstuvwxyz";
    for (var i = 0; i < 5; i++) {
      className += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    const trigger = document.createElement('div');
    trigger.setAttribute("class", 'trigger-' + className);
    el.before(trigger);

    let duration, delay, offset;
    if (binding.value) {
      duration = binding.value.duration || 1000;
      delay = binding.value.delay || 0;
      offset = binding.value.offset || 0;
    } else {
      duration = 1000;
      delay = 0;
      offset = 0;
    }

    const scene = new ScrollMagic.Scene({
      triggerElement: trigger,
      triggerHook: 0.8,
      offset: offset,
      reverse: false
    });

    scene.setTween(TweenMax.to(el, duration / 1000, {
      opacity: 1,
      y: 0,
      delay: delay / 1000
    }))
      .addTo(controller);

    if (binding.arg) {
      scene.addIndicators();
    }
  }
})


// WEBPACK FOOTER //
// ./src/js/directives/scroll-reveal/scroll-reveal.js